module.exports = __webpack_public_path__ + "static/media/construction.d0c67b22.svg";